export const getNiceDate = (date: string): string => {
  return date ? new Date(date)?.toLocaleDateString() : "/";
};
